import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    itemId: '',
    clazzId: '',
    cri: '',
    coursewareId: '',
    mediaIds: '',
    ts: 0,
    firstEntryClassList: true,
    className: '',
    classDesc: '',
    readTs: null,
    classListTs: null,
    userId: null,
    facerecog: false,
    faceRecognitionType: 0,
    faceRecognitionSuccess: false,
    targetRoute: null,
    navTitle: '',
    currentMaxVideo: 0,
    currentPlayVideoIndex: 0,
    videoNode: [],
    replayTs: 0,
    videoMap: {},
    videoPoints: {},
    mixLog: {},
    loginPage: true,
    examTitle: '',
    nextItemTs: 0,
    userTapItem: false,
    updateNodeTs: 0,
    nextVideo: 0,
    prevVideo: 0,
    updateVideo: '0_0',
    currentVideo: 0,
    errMsg: '',
    updateOutline: 0,
    tenantInfo: {},
    pauseTs: 0,
    checkDialogTs: 0,
    checkModalTs: 0,
    updateResignTs: 0,
		signOutTs: 0,
  },
  mutations: {
		exitCoursewareByNeedSignOut(state) {
			state.signOutTs = Date.now()
		},
    updateResign(state) {
      state.updateResignTs = Date.now()
    },
    checkDialog(state) {
      state.checkDialogTs = Date.now()
    },
    checkModal(state) {
      state.checkModalTs = Date.now()
    },
    pause(state) {
      state.pauseTs = Date.now()
    },
    setTenant(state, info) {
      state.tenantInfo = info
    },
    updateOutline(state) {
      state.updateOutline = Date.now()
    },
    bindError(state, msg) {
      state.errMsg = msg
    },
    tapNextVideo(state) {
      state.nextVideo = Date.now()
    },
    tapPrevVideo(state) {
      state.prevVideo = Date.now()
    },
    tapCustomVideo(state, index) {
      state.updateVideo = `${Date.now()}_${index}`
    },
    loadCurrentVideo(state) {
      state.currentVideo = Date.now()
    },
    updateNodeStatus(state) {
      state.updateNodeTs = Date.now()
    },
    changeUserTapItem(state, type){
      state.userTapItem = type
    },
    playNextItem(state) {
      state.nextItemTs = Date.now()
    },
    changeExamTitle(state, title) {
      state.examTitle = title
    },
    hasLoginPage(state, type){
      state.loginPage = type
    },
    changeMixLog(state, log){
      state.mixLog = log
    },
    changeVideoMap(state, vmap) {
      state.videoMap = vmap
    },
    changeVideoPoint(state, vpoint) {
      state.videoPoints = vpoint
    },
    replayNode(state) {
      state.replayTs = Date.now()
    },
    renderVideoNodt(state, nodeArr) {
      state.videoNode = nodeArr
    },
    changeVideoCount(state, videoCount) {
      state.currentMaxVideo = videoCount
    },
    changeCurrentVideoIndex(state, videoIndex) {
      state.currentPlayVideoIndex = videoIndex
    },
    changeItemId(state, itemId) {
      state.itemId = itemId
    },
    changeClazzId(state, clazzId) {
      state.clazzId = clazzId
    },
    changeCri(state, cri) {
      state.cri = cri
    },
    changeCoursewareId(state, coursewareId) {
      state.coursewareId = coursewareId
    },
    changeMediaIds(state, mediaIds) {
      state.mediaIds = mediaIds
    },
    changeTs(state, ts){
      state.ts = ts
    },
    changeClassListEntryType(state, type) {
      state.firstEntryClassList = type
    },
    changeClassName(state, className){
      state.className = className
    },
    changeClassDesc(state, classDesc){
      state.classDesc = classDesc
    },
    updateClassDetailByRead(state, ts){
      state.readTs = ts
    },
    updateClassList(state){
      state.classListTs = Date.now()
    },
    changeUserId(state, userId){
      state.userId = userId
    },
    needFaceRecognition(state, type){
      if(!state.facerecog){
        state.facerecog = true
      }
      state.faceRecognitionType = type
    },
    faceRecognitionSuccess(state){
      state.facerecog = false
      state.faceRecognitionSuccess = true
    },
    faceRecognitionCancel(state){
      state.facerecog = false
      state.faceRecognitionSuccess = false
    },
    saveTargetRoute(state, route){
      state.targetRoute = route
    },
    changeNav(state, title) {
      state.navTitle = title
    }
  },
  actions: {
    changeVideo({ commit, state }, obj){
      commit('changeClazzId', obj.clazzId)
      commit('changeCri', obj.cri)
      commit('changeMediaIds', obj.mediaIds)
      commit('changeItemId', obj.itemId)
    }

  },
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    reducer(val) {
      return {
        clazzId: val.clazzId,
        cri: val.cri,
        coursewareId: val.coursewareId,
        userId: val.userId,
        tenantInfo: val.tenantInfo,
      }
    }
  })]
})
